import { catalog } from "./catalog";
import { cart } from "./cart";
import { wishlist } from "./wishlist";
import { addresses } from "./addresses";
import { astrologers } from "./astrologers";
import { blog } from "./blog";
import { courses, cleanVideoUrl, videoWatchUrl, courseInstructors, primaryInstructor } from "./courses";
import { certificates } from "./certificates";
import { liveClasses } from "./liveClasses";
import { liveStreams } from "./liveStreams";
import { lookups } from "./lookups";
import { dashboard } from "./dashboard";
import { payments } from "./payments";
import { checkout } from "./checkout";
import { bookings } from "./bookings";
import { videosdk } from "./videosdk";
import { suggestedProducts } from "./suggestedProducts";
import { reviews } from "./reviews";
import { newsletter } from "./newsletter";
import { gallery } from "./gallery";
import { faqs, unwrapFaqList } from "./faqs";
import { generalSettings } from "./generalSettings";
import { contact } from "./contact";
import { puja } from "./puja";
import { livekit } from "./livekit";
import { kundlis } from "./kundlis";
import { shipping } from "./shipping";

/** Namespaced endpoint groups: api.catalog.list(), api.astrologers.filter()… */
export const api = {
  catalog,
  cart,
  wishlist,
  addresses,
  astrologers,
  blog,
  courses,
  certificates,
  liveClasses,
  liveStreams,
  lookups,
  dashboard,
  payments,
  checkout,
  bookings,
  videosdk,
  suggestedProducts,
  reviews,
  newsletter,
  gallery,
  faqs,
  generalSettings,
  contact,
  puja,
  livekit,
  kundlis,
  shipping,
};

export {
  catalog,
  cart,
  wishlist,
  addresses,
  astrologers,
  blog,
  courses,
  cleanVideoUrl,
  videoWatchUrl,
  courseInstructors,
  primaryInstructor,
  certificates,
  liveClasses,
  liveStreams,
  lookups,
  dashboard,
  payments,
  checkout,
  bookings, videosdk, suggestedProducts, newsletter,
  reviews,
  gallery,
  faqs,
  unwrapFaqList,
  generalSettings,
  contact,
  puja,
  livekit,
  kundlis,
  shipping,
};
export {
  liveStreamRows,
  liveStreamViewerLabel,
  liveStreamElapsed,
  liveStreamAstrologerName,
} from "./liveStreams";
export type {
  LiveStream,
  LiveStreamAstrologer,
  LiveStreamListResponse,
  LiveStreamEnvelope,
  LiveStreamSession,
  LiveStreamSessionResponse,
  LiveStreamHeartbeat,
  LiveStreamChatMessage,
  LiveStreamChatPage,
  GoLivePayload,
} from "./liveStreams";
export type { SavedKundli, SaveKundliPayload, KundliListParams, KundliSource, KundliSort, UpdateKundliPayload } from "./kundlis";
export type { DeliveryEstimate, DeliveryEstimateResponse, PublicTracking } from "./shipping";
export type {
  LivekitDevRole,
  LivekitDevTokenParams,
  LivekitDevTokenResponse,
  LivekitTokenResponse,
} from "./livekit";
export {
  resolveVideoSession,
  describeVideoSessionError,
  isJwtShaped,
  decodeJwtPayload,
  encodeClockAnchor,
  decodeClockAnchor,
  mergeClockAnchor,
} from "./videoSession";
export type {
  VideoProvider,
  VideoSession,
  VideoSessionError,
  VideoSessionResult,
  ClockAnchor,
} from "./videoSession";
export type {
  JoinConsultationPayload,
  JoinConsultationResponse,
  EndConsultationResponse,
} from "./bookings";
export type {
  PujaEnvelope,
  PujaMeta,
  PujaCategory,
  PujaScheduleType,
  PujaListItem,
  PujaListParams,
  PujaDetail,
  PujaPackage,
  PujaPackageFeature,
  PujaFaq,
  PujaTempleSummary,
  PujaTempleDetail,
  PujaDevoteePayload,
  PujaAddressPayload,
  CreatePujaBookingPayload,
  PujaBooking,
  PujaBookingDevotee,
  PujaBookingAddress,
  PujaRazorpayOrder,
  VerifyPujaPaymentPayload,
} from "./puja";
export type { SubscribePayload, SubscribeResponse } from "./newsletter";
export type {
  SuggestedProductRow,
  SuggestedProductInfo,
  SuggestedProductsResponse,
  SuggestProductPayload,
  RemoveSuggestedProductPayload,
} from "./suggestedProducts";
export type { VideosdkTokenResponse, VideosdkRoomResponse } from "./videosdk";
export type {
  CheckoutCartItem,
  PlaceOrderPayload,
  PlaceOrderResponse,
  VerifyPaymentPayload,
  VerifyPaymentResponse,
} from "./checkout";
export type {
  Product,
  ProductCategory,
  ProductGrade,
  ProductSearchParams,
  SearchProduct,
  ResourcePaginator,
  LaravelPaginator,
  Envelope,
} from "./catalog";
export type {
  AddToCartPayload,
  AddToCartResponse,
  BuyNowPayload,
  CartItem,
  CartTotals,
  CartCount,
  UpdateCartQuantityPayload,
  DeleteCartItemPayload,
  ApplyCouponPayload,
  ApplyCouponResponse,
} from "./cart";
export type {
  Address,
  SaveAddressPayload,
  UpdateAddressPayload,
  AddressMutationResponse,
} from "./addresses";
export type { WishlistItem, WishlistMutationResponse, WishlistCount } from "./wishlist";
export type {
  Astrologer,
  AstrologerFilterParams,
  AstrologerFilterResponse,
  AstrologerListMeta,
  AstrologerListResponse,
  AstrologerApplication,
  AstrologerOnboardingPayload,
  AstrologerOnboardingResponse,
  AstrologerOnboardingStatus,
  AstrologerProfileUpdatePayload,
  AstrologerRegistrationPayload,
  AstrologerRegistrationResponse,
  AvailabilitySlot,
  PricingSlabsPayload,
  PricingSlabsResponse,
} from "./astrologers";
export { BLOG_MARKUP_HELP } from "./blog";
export type {
  BlogPost,
  BlogCategory,
  BlogAuthor,
  BlogPostStatus,
  BlogPostsParams,
  MyBlogPost,
  MyBlogPostsResponse,
  MyBlogPostPayload,
  BlogPostEnvelope,
  BlogImageUploadResponse,
} from "./blog";
export type {
  Course,
  CourseInstructor,
  CourseLesson,
  CourseCurriculumSession,
  EmbeddedLiveClass,
  EmbeddedRecording,
  CourseListParams,
  CoursesListResponse,
  Enrollment,
  EnrollPayload,
  CourseProgress,
  ValidateCouponResponse,
  CourseCheckoutOrderResponse,
  CourseCheckoutVerifyPayload,
  CourseCheckoutVerifyResponse,
  CourseCategory,
  CourseCategoriesResponse,
  CreateCoursePayload,
  CreatedCourse,
  CreateCourseResponse,
  CreateLessonPayload,
  CreatedLesson,
  CreateLessonResponse,
} from "./courses";
export type { Certificate, VerifyCertificateResponse } from "./certificates";
export type {
  LiveClass,
  LiveClassListResponse,
  CreateLiveClassPayload,
  MyLiveClassesResponse,
  JoinLiveClassResponse,
  LiveClassRecordingResponse,
} from "./liveClasses";
export { parseLiveClassTime } from "./liveClasses";
export type { Skill, Language, LocationItem } from "./lookups";
export { INDIA_COUNTRY_ID } from "./lookups";
export type { PaymentGateway } from "./payments";
export type {
  DashboardUser,
  UpdateProfilePayload,
  Booking,
  Order,
  OrderItem,
  OrderTrackStep,
  OrderTrackData,
  OrderShipment,
  ShipmentActivity,
  ShipmentStage,
  ShipmentEvent,
  ShipmentNdr,
  NdrResponseInput,
} from "./dashboard";
export { bookingByIdPath } from "./bookings";
export type {
  AvailableSlot,
  AvailableSlotsResponse,
  BookingAstrologer,
  BookingDetail,
  BookingRecord,
  BookingCategory,
  GemstoneConsultation,
  GemstoneSlotsResponse,
  GemstoneSettingsPayload,
  CreateBookingPayload,
  CreateBookingAfterPaymentPayload,
  RescheduleBookingPayload,
  RazorpayOrderPayload,
  RazorpayOrderResponse,
  RazorpayVerifyPayload,
  RazorpayVerifyResponse,
} from "./bookings";
export type {
  Review,
  ReviewAuthor,
  ReviewableType,
  ReviewsListParams,
  ReviewsListResponse,
  ReviewSummary,
  ReviewSummaryResponse,
  ReviewsSummaryParams,
  SubmitReviewPayload,
  SubmitReviewResponse,
} from "./reviews";
export type {
  GalleryItem,
  GalleryListParams,
  GalleryListResponse,
  GalleryItemResponse,
} from "./gallery";
export type { Faq, FaqType, FaqListParams, FaqListResponse, NormalizedFaq } from "./faqs";
export type { GeneralSettings, GeneralSettingsResponse, SocialLinkEntry } from "./generalSettings";
export type { ContactInterest, ContactSubmitPayload, ContactSubmitResponse } from "./contact";
